export class UpdateQuesRes{
    constructor(
        public QuestionID?:any[],
        public Question?: any[],
        public Response?: any[]) {}
        
}